import config from "../../Utility/ConfigUtility";

const alert = (item) => {
    if(item?.response?.status === 401){
        window.localStorage.clear();
        window.location.href = config.redirectBaseUrl + '/' + config.subPath;
        return;
    }

    const string = typeof(item) === 'object' ? item.message : item;
    let toast = window.document.body.querySelector('.toast');
    if(!toast){
        toast = window.document.createElement('DIV');
        toast.setAttribute('class','toast');
        window.document.body.querySelector('#root').appendChild(toast);
    }
    toast.classList.remove('disapear');
    toast.innerHTML = `
        <h2>Something went wrong !</h2>
        <br />
        <p>Please contact the administrator for the solution.</p>
        <br /><br /><br />
        <div class="buttons flex" style="gap : 10px;"></div>
    `;
    const buttons = toast.querySelector('.buttons');
    const spacer = document.createElement('DIV');
    spacer.setAttribute('class','spacer');
    buttons.appendChild(spacer);

    const detailsButton = document.createElement('INPUT');
    detailsButton.setAttribute('type','button');
    detailsButton.setAttribute('value','Copy logs');
    detailsButton.setAttribute('class','secondary');
    buttons.appendChild(detailsButton);
    detailsButton.addEventListener('click', e => {
        e.target.value = 'Copied';
        navigator.clipboard.writeText(string);
    });

    const okButton = document.createElement('INPUT');
    okButton.setAttribute('type','button');
    okButton.setAttribute('value','OK');
    okButton.setAttribute('class','primary');
    okButton.addEventListener('click', _ => toast.classList.add('disapear'));
    buttons.appendChild(okButton);
}

export { alert };
